import { Component } from '@angular/core';

@Component({
    selector: 'vb-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent {}
